import {
  Box
} from '@mui/material'

import { useContext } from 'react'

// Context
import { StatsDataContext } from 'src/store/stats/Store'
import { NavigationDataContext, NavigationDispatchContext } from 'src/store/navigation/Store'
import { setSwitch } from 'src/store/navigation/actions'
import { InventoryDataContext } from 'src/store/inventory/Store'

import Sprite from './Sprite'

const spriteContainer = {
  width: '48px',
  height: '48px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  pointerEvents: 'auto',
  position: 'relative',
  border: '2px solid white'
}

const MenuButtons = () => {
  const { navigation } = useContext(NavigationDataContext)
  const { inventory } = useContext(InventoryDataContext)
  const { stats } = useContext(StatsDataContext)
  const { dispatchNavigation } = useContext(NavigationDispatchContext)

  const toggleMenu = () => {
    setSwitch(dispatchNavigation, 'menu_open', !navigation.menu_open)
  }
  

  return (
    <Box sx={{...spriteContainer, backgroundColor: inventory.equipped.head === 'headlamp' ? 'yellow' : 'transparent'}} onClick={toggleMenu} className='stats_icon'>
      {
        stats.player.player_hp < 1 ? (
          <Sprite spriteID='boy_head_dead'/>
        ) : stats.player.player_hp < stats.player.player_hp_max / 4 ? (
          <Sprite spriteID='boy_head_near_death'/>
        ) : stats.player.player_hp < stats.player.player_hp_max / 2 ? (
          <Sprite spriteID='boy_head_injured'/>
        ) : (
          <Sprite spriteID='boy_head'/>
        )
      }
      
      {
        inventory.equipped.head === 'headlamp' ? (
          <Sprite spriteID='boy_head_lamp'/>
        ) : null
      }
    </Box>
  )
}

export default MenuButtons
